import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-temp-guage',
  templateUrl: './temp-guage.component.html',
  styleUrl: './temp-guage.component.css'
})
export class TempGuageComponent{

  @Input()
  gaugeValue: any =40;

  @Input()
  gaugeLabel = "";

  @Input()
  gaugeAppendText = "";

  @Input()
  min=0

  @Input()
  max=100

  @Input()
  thresholds={}

  thresholdConfig = {
    '0': {color: 'green'},
    '30': {color: 'orange'},
    '40': {color: 'red'}
};

}
